'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAnyCompanyLogo = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _keyPaths = require('./keyPaths');

var _getCompanyLogo = require('./getCompanyLogo');

var _getFallback = require('./getFallback');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAnyCompanyLogo = exports.getAnyCompanyLogo = function getAnyCompanyLogo(chatHeadingConfig) {
  return (0, _getIn2.default)(_keyPaths.COMPANY_LOGO, chatHeadingConfig) || (0, _getCompanyLogo.getCompanyLogo)((0, _getFallback.getFallback)(chatHeadingConfig));
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/chat-heading-config/operators/getAnyCompanyLogo.js
// module id = 504
// module chunks = 2 3